import { ref } from 'vue';

export const isLoading = ref(false);
